export default __webpack_public_path__ + "static/media/placeholder_dummy2016-mode01-de.c6f1c141.png";